import React, { FC, useEffect, useState } from 'react';
import { createStyles, makeStyles, Table, TableBody, TableHead, TableRow, Typography } from '@material-ui/core';

import HeaderRow from 'components/HeaderRow';
import BodyRow from './components/BodyRow';
import BodyCell from 'components/BodyCell';
import TablePagination from 'components/TablePagination';
import { dummyAppLog } from 'constants/dummy';

interface Props {
  isLoadingData: boolean;
  appLogs: AppLogModel[];
  count: number;
  currentPage: number;
  rowsPerPage: number;
  handleChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
  handleChangeRowsPerPage: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  onFilterUser: (user: { id: number; name: string }) => void;
  onFilterEntity: (entity: { type: string; id: number; label: string }) => void;
  onFilterRequest: (requestId: string) => void;
}

const headers = [
  { label: '' },
  { label: 'Time' },
  { label: 'User' },
  { label: 'Record' },
  { label: 'Description' }
];

const useStyles = makeStyles(() =>
  createStyles({
    tableWrapper: {
      overflowX: 'auto'
    }
  })
);

const AppLogTable: FC<Props> = props => {
  const classes = useStyles();

  const { isLoadingData, appLogs, count, currentPage, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = props;
  const { onFilterUser, onFilterEntity, onFilterRequest } = props;

  const renderRow = (appLog: AppLogModel, index: number, key: number) => (
    <BodyRow
      index={index}
      key={key}
      appLog={appLog}
      isLoadingData={showSkeleton}
      columnCount={headers.length}
      onFilterUser={onFilterUser}
      onFilterEntity={onFilterEntity}
      onFilterRequest={onFilterRequest}
    />
  );

  // The below logic introduces a 500ms delay for showing the skeleton
  const [showSkeleton, setShowSkeleton] = useState<boolean>(false);
  useEffect(() => {
    if (isLoadingData) {
      setShowSkeleton(true);
    }

    return () => {
      setShowSkeleton(false);
    };
  }, [isLoadingData]);

  // headerNameWithPaddings['headerName:pL:pR:pT:pB']
  return (
    <div className={classes.tableWrapper}>
      <Table>
        <TableHead>
          <HeaderRow headers={headers} />
        </TableHead>
        <TableBody>
          {isLoadingData ? (
            [1, 2, 3, 4, 5].map(index => renderRow(dummyAppLog, index, index))
          ) : appLogs.length > 0 ? (
            appLogs.map((appLog, index) => renderRow(appLog, index, appLog.id))
          ) : (
            <TableRow>
              <BodyCell colSpan={headers.length}>
                <Typography variant='body2' color='textSecondary' style={{ textAlign: 'center' }}>
                  No matching result
                </Typography>
              </BodyCell>
            </TableRow>
          )}
        </TableBody>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15]}
          count={count}
          rowsPerPage={rowsPerPage}
          page={currentPage}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Table>
    </div>
  );
};

export default AppLogTable;
